import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertMessageService, CookieService } from '@sbt-suite/components';
import {
    BehaviorSubject,
    Observable,
    catchError,
    filter,
    finalize,
    switchMap,
    take,
    throwError
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { IResponseAuthLogin } from '../models';
import { AutenticacaoService } from '../services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    MODE = environment.MODE;
    isGetToken: boolean = false;
    tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private _router: Router,
        private alertMessage: AlertMessageService,
        private _cookie: CookieService,
        private _autenticacaoService: AutenticacaoService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 && error.error.message === 'Refresh Token Expirado') {
                    this.showAlert(error);
                    this._clearSession();
                }

                if (this.isGetToken) {
                    return this.tokenSubject.pipe(
                        filter((_token) => _token),
                        take(1),
                        switchMap((newToken) => {
                            const req = this._addTokenToHeader(request, newToken);
                            return next.handle(req);
                        })
                    );
                } else if (error.status === 401) {
                    if (error.error.message === 'Token expirado') {
                        this.isGetToken = true;
                        this.tokenSubject.next(null);
                        const token = this._cookie.get(environment.REFRESH_TOKEN);
                        return this.handleTokenRefresh(request, next, token);
                    } else if (!this.isGetToken) {
                        this.showAlert(error);
                        this._clearSession();
                    }
                }

                return throwError(() => error);
            })
        );
    }

    showAlert(error: HttpErrorResponse) {
        this.alertMessage.mostrarAlerta(`${error?.error?.message || error?.message}`);
    }

    private _clearSession() {
        localStorage.clear();
        this._autenticacaoService.clearCookie();
        this._autenticacaoService.setUsuarioAutenticado(false);
        this._router.navigateByUrl('/login');
    }

    private handleTokenRefresh(
        request: HttpRequest<any>,
        next: HttpHandler,
        token: string
    ): Observable<HttpEvent<any>> {
        return this._autenticacaoService.refreshToken(token).pipe(
            switchMap((response: IResponseAuthLogin) => {
                this._autenticacaoService.setTokenUsuario(
                    response.access_token,
                    response.refresh_token
                );

                this.tokenSubject.next(response.access_token);
                const req = this._addTokenToHeader(request, response.access_token);
                return next.handle(req);
            }),
            catchError((error: any) => {
                this._clearSession();
                return throwError(() => error);
            }),
            finalize(() => (this.isGetToken = false))
        );
    }

    private _addTokenToHeader(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
        const _req = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return _req;
    }
}
